<template>
  <dl class="accordion box">
    <AccordionItem
      v-for="item in content"
      :multiple="multiple"
      :item="item"
      :groupId="groupId"
      :key="item.id">
    </AccordionItem>
  </dl>
</template>

<script>
import AccordionItem from '@/components/custom/AccordionItem';

export default {
  props: {
    content: {
      type: Array,
      required: true
    },
    multiple: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      groupId: null
    }
  },
  components: { AccordionItem },
  mounted() {
    this.groupId = this.$el.id
  }
}
</script>

<style lang="stylus" scoped>
.accordion
  padding 0
  margin 0

</style>
